<template>
  <svg viewBox="0 0 600 600" :class="{ active: changeColor }">
    <path d="M550,290.04c-2.59-131.43-108.6-237.45-240.04-240.04v240.04h240.04Z" />
    <path
      d="M297.15,309.84l-138.93,198.42c39.08,26.35,86.16,41.74,136.84,41.74,133.7,0,242.32-107.09,244.94-240.16h-242.84Z"
    />
    <path
      d="M290.16,60c-133.07,2.62-240.16,111.24-240.16,244.94,0,81.15,39.47,153.05,100.23,197.65l139.93-199.85V60Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    changeColor: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  path {
    fill: $white;
  }

  &.active path {
    fill: $white;
  }
}

.light svg {
  path {
    fill: $gray-6;
  }

  &.active path {
    fill: $white;
  }
}
</style>
